import { IonIcon } from '@ionic/react';
import { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useHistory } from 'react-router';

const SearchBar = ({
  keywords,
  setKeywords,
  minKeywordChar,
  resultsCount,
  search,
  reset,
  clear,
  isCleared,
}) => {
  const [doSearch, setDoSearch] = useState<boolean>(false);

  const history = useHistory();

  const intl = useIntl();

  useEffect(() => {
    // wait pagination has been reset before searching again
    if (isCleared() && doSearch) {
      setDoSearch(false);
      search(keywords);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCleared(), doSearch]);

  return (
    <form
      className="flex gap-2 items-center w-full"
      onSubmit={(e) => {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }}
    >
      <div className="rounded-full w-full border border-gray-200 md:border-none px-3 py-2 md:px-6 md:py-4 bg-white flex items-center justify-center">
        <button
          type="submit"
          onClick={() => {
            clear();
            setDoSearch(true);
          }}
          value="search"
          className="flex items-center justify-center"
        >
          <IonIcon
            name="search-outline"
            className={`h-6 w-6 p-1.5 rounded-full cursor-pointer ${
              keywords.length > 1 ? 'bg-primary text-white' : 'text-gray-600'
            }`}
          ></IonIcon>
        </button>
        <input
          className="h-10 flex-auto rounded-full appearance-none border-none focus:border-none focus:ring-0 active:ring-0"
          type="search"
          placeholder={intl.formatMessage({ id: 'Search' })}
          onChange={(event) => setKeywords(event.target.value)}
          value={keywords}
        />
        <IonIcon
          name="close"
          className="h-5 w-5 p-1 rounded-full bg-primary text-white cursor-pointer"
          onClick={() => {
            setKeywords('');
            reset();
            history.push('/search/');
          }}
        ></IonIcon>
      </div>
      {keywords.length >= minKeywordChar && (
        <button
          onClick={() => {
            clear();
            setDoSearch(true);
          }}
          type="submit"
          className="hidden"
        >
          {/* <FormattedMessage id="Search" /> */}
          <IonIcon name="search-outline"></IonIcon>
        </button>
      )}
      {(resultsCount > 0 || keywords.length > 0) && (
        <button
          type="submit"
          onClick={() => {
            setKeywords('');
            reset();
          }}
          className="text-primary p-2 hidden"
        >
          <FormattedMessage id="Search Reset" />
        </button>
      )}
    </form>
  );
};

export default SearchBar;
